import { render, staticRenderFns } from "./freight_.vue?vue&type=template&id=5c16a8b4&scoped=true"
import script from "./freight_.vue?vue&type=script&lang=js"
export * from "./freight_.vue?vue&type=script&lang=js"
import style0 from "./freight_.vue?vue&type=style&index=0&id=5c16a8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c16a8b4",
  null
  
)

export default component.exports